import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import i18n from "./../i18n";
import store from "./../store";


axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API : "";

Vue.use(VueAxios, axios);

// Add a request interceptor
Vue.axios.interceptors.request.use(function (config) {
  if(config.authenticate) {
    const connected = Vue.prototype.$auth.user();
    config.headers['x-api-key'] = connected.application.api_key;
    config.headers['secret'] = connected.application.secret;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});



Vue.axios.interceptors.response.use(function(response) {
  const config = response.config;
  const messages = config.messages;
  const notification = config.notification || {};
  const status = response.status;
  if (messages) {
    if (messages[status]) {
      if (typeof messages[status] === "string") {
        store.dispatch("notification/notify", {
          message: messages[status],
          ...notification
        });
      } else if (typeof messages[status] === "function") {
        store.dispatch("notification/notify", {
          message: messages[status](response.data),
          ...notification
        });
      }
    }
  }
  return response;
},
function(error) {
  const config = error.config;
  const messages = config.messages;
  const notification = config.notification || {};
  if (error && error.response) {
    const status = error.response.status;
    const data = error.response.data;
    if (messages) {
      if (messages[status]) {
        if (typeof messages[status] === "boolean") {
          store.dispatch("notification/notify", {
            message: i18n.t(`errors.${status}E`),
            ...notification
          });
        } else if (typeof messages[status] === "string") {
          store.dispatch("notification/notify", {
            message: messages[status],
            ...notification
          });
        } else if(typeof messages[status] === "object") {
          const code = Vue.$objectPath.get(data, 'code');
          if(Vue.$objectPath.has(messages[status], code)) {
            const message = messages[status][code];
            if(typeof message === 'boolean') {
              store.dispatch("notification/notify", {
                message: i18n.t(`errors.${code}E`),
                ...notification
              })
            } else if(typeof message === 'function') {
              store.dispatch("notification/notify", {
                message: message(data),
                ...notification
              })
            } else {
              store.dispatch("notification/notify", {
                message: message,
                ...notification
              })
            }
          }else if(Vue.$objectPath.has(messages[status], 'other')) {  
            store.dispatch("notification/notify", {
              message: messages[status]['other'](data),
              ...notification
            })
          }
        } else if (typeof messages[status] === "function") {
          const message = messages[status](data);
          if (message) {
            store.dispatch("notification/notify", {
              message: messages[status](data),
              ...notification
            });
          }
        }
      }
    }
  }
  return Promise.reject(error);
})
